import { setResources } from "./bootstrapResources";
import serverReference from "./serverReference-nl-NL.json";
import resources from "./translations-nl-NL.json";

setResources(resources, serverReference);